module.exports = __webpack_public_path__ + "img/anti-counterfeiting-button.3160e2c5.png";